const numberFormat = price => {
  return new Intl.NumberFormat('ru-RU').format(price);
};

export default numberFormat;
